import validate from "/app/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@types+node@25.9.5_@vue+compiler-sfc@3.5.41_cac@6.7.1_4r6qclturvbiep7j6bdfrzcnom/node_modules/nuxt/dist/pages/runtime/validate.js";
import admin_45global from "/app/middleware/admin.global.ts";
import default_45global from "/app/middleware/default.global.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@types+node@25.9.5_@vue+compiler-sfc@3.5.41_cac@6.7.1_4r6qclturvbiep7j6bdfrzcnom/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  admin_45global,
  default_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/middleware/auth.ts")
}